import { render } from "./TrainerVideos.vue?vue&type=template&id=5a11bf1d&scoped=true&ts=true"
import script from "./TrainerVideos.vue?vue&type=script&lang=ts"
export * from "./TrainerVideos.vue?vue&type=script&lang=ts"

import "./TrainerVideos.vue?vue&type=style&index=0&id=5a11bf1d&scoped=true&lang=css"

import exportComponent from "/home/runner/work/studiostvapp/studiostvapp/PlatformStudiosApp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a11bf1d"]])

export default __exports__